module.exports = __webpack_public_path__ + "static/img/product_images_24_h5_zh.7581641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_24_h5_zh.png
// module id = NMhN
// module chunks = 34